"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSession = void 0;
const ramda_1 = require("ramda");
const utils_1 = require("@hc-frontend/utils");
const __1 = require("../../");
function queryObjectToTracking(queryValues) {
    // URL parameters that will be tracked for changes
    const keys = [
        'subid',
        'aid',
        'pubid',
        'gclid',
        'msclkid',
        'irpid',
        'ircid',
        'src',
        'iv',
        'pcid',
        'pr_pid',
        'utm_source',
        'utm_campaign',
        'utm_medium',
        'utm_content',
        'utm_term',
        'agent_id',
    ];
    let hasValue = false;
    const result = {};
    for (const key of keys) {
        if (queryValues[key]) {
            result[key] = queryValues[key];
            hasValue = true;
        }
    }
    // Maps URL keys with different name
    const MAP_KEYS = [
        ['src', 'source'],
        ['iv', 'bt_sid'],
    ];
    for (const [key, value] of MAP_KEYS) {
        if (!result[key] && queryValues[value]) {
            result[key] = queryValues[value];
            hasValue = true;
        }
    }
    return hasValue ? result : null;
}
function getIDs(queryValues) {
    const uid = (0, __1.isValidUserId)(queryValues.uid) ? queryValues.uid : undefined;
    const sid = (0, __1.isValidSessionId)(queryValues.sid) ? queryValues.sid : undefined;
    const email = (0, utils_1.isValidEmail)(queryValues.email) ? queryValues.email : undefined;
    return [uid, sid, email];
}
function process(local, url) {
    const value = url || local;
    let keepCurrent = Boolean(local);
    if (keepCurrent && url) {
        keepCurrent = (0, ramda_1.equals)(local, url);
    }
    return {
        value: value ? value : undefined,
        keepCurrent,
    };
}
async function updateSession(provider) {
    var _a, _b;
    const queryValues = provider.getQueryValues();
    const local_session = provider.getCurrentSession();
    const [url_uid, url_sid, url_email] = getIDs(queryValues);
    const url_tracking = queryObjectToTracking(queryValues);
    const { uid: local_uid, sid: local_sid, email: local_email, tracking: local_tracking, } = local_session || {};
    const uid = process(local_uid, url_uid);
    const sid = process(local_sid, url_sid);
    const email = process(local_email, url_email);
    const tracking = process(local_tracking, url_tracking);
    if (tracking.keepCurrent &&
        uid.keepCurrent &&
        sid.keepCurrent &&
        email.keepCurrent) {
        return local_session;
    }
    // return await createSession({
    // })
    tracking.value = {
        ...tracking.value,
        src: ((_a = tracking.value) === null || _a === void 0 ? void 0 : _a.src) || '',
        agent_id: ((_b = tracking.value) === null || _b === void 0 ? void 0 : _b.agent_id) || '2010000',
    };
    const errorOnSaveTracking = !provider.saveTracking(tracking.value);
    if (errorOnSaveTracking) {
        provider.logError(new Error('Error on save session tracking'));
    }
    const session = await provider.fetchNewSession({
        tracking: tracking.value,
        uid: uid.value,
        sid: sid.value,
        email: email.value || null,
    }, provider.getLoggedAgentId());
    return session;
}
exports.updateSession = updateSession;
//# sourceMappingURL=update-session.js.map